import { useState, type FormEvent } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Theme } from '../components/Theme';
import { api } from '../services/api';
import { useGame } from '../hooks/useGame';
import { ErrorState, LoadingState } from '../components/LoadingState';

export function AdminLoginPage() {
  const { slug = '' } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { game, loading, error } = useGame(slug);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  if (loading) return <LoadingState />;
  if (error || !game) return <ErrorState message={error || 'Juego no encontrado.'} />;

  const submit = async (event: FormEvent) => {
    event.preventDefault(); setSubmitting(true); setMessage('');
    try { await api.adminLogin(username, password); const redirect = new URLSearchParams(location.search).get('redirect') || `/admin/${slug}`; navigate(redirect, { replace: true }); }
    catch (reason) { setMessage(reason instanceof Error ? reason.message : 'No se pudo iniciar sesión.'); }
    finally { setSubmitting(false); }
  };
  return <Theme theme={game.theme}><main className="center-screen"><form className="admin-login-card" onSubmit={submit}><div className="celebration-burst admin-login-icon">♥</div><p className="eyebrow">Zona privada</p><h1>Administración</h1><p>Ingresá para editar {game.title}.</p>{message && <p className="form-error">{message}</p>}<label>Usuario<input autoComplete="username" autoFocus value={username} onChange={(event) => setUsername(event.target.value)} /></label><label>Contraseña<input autoComplete="current-password" type="password" value={password} onChange={(event) => setPassword(event.target.value)} /></label><button className="button button-primary button-large" disabled={submitting || !username || !password}>{submitting ? 'Ingresando…' : 'Ingresar'}</button><button className="button button-ghost" type="button" onClick={() => navigate(`/game/${slug}`)}>Volver al juego</button></form></main></Theme>;
}

